import React, { ChangeEvent, useEffect, useState } from 'react';
import { usePdvOnline } from '~/pages/PdvOnline/hooks/usePdvOnline';
import { Modal } from '..';
import { ButtonContainer } from './styles';
import { moneyFormat } from '~/utils/functions';
import { CardTotalizadores } from '../../Totalizadores/styles';
import { Row, Col } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { InputMoney, InputPercent } from '~/components/NovosInputs';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { formatToCurrency } from '~/pages/AlteracaoDePrecoPorItem/utils/formatToCurrency';
import { convertToDecimal } from '~/pages/AlteracaoDePrecoPorItem/utils/convertToDecimal';
import { pesoFormatado } from '~/pages/Ncm/formatMask';
import { toast } from 'react-toastify';
import { subTotalTable } from '../../TabProdutos/utils/calcSubTotalTable';

export const ModalDesconto: React.FC = () => {
  const {
    isOpenModalDesconto,
    handleChangeOpenModalDesconto,
    subTotal,
    val_acrescimo,
    val_desconto,
    val_desconto_max,
    handleValAcrescimo,
    handleValDesconto,
    handleSubTotal,
    produtosTable,
  } = usePdvOnline();
  const {
    register,
    control,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const [newSubTotal, setNewSubTotal] = useState<number>(0);
  const [newSubTotalLiquido, setNewSubTotalLiquido] = useState<number>(0);
  const [valAcrescimo, setValAcrescimo] = useState<number>(0);
  const [valDesconto, setValDesconto] = useState<number>(0);

  const handleCalcDesconto = (attribute: string, value: number) => {
    let auxSubTotal = 0;
    let percDesconto = 0;
    let percAcrescimo = 0;
    let valueDesconto = 0;
    let valueAcrescimo = 0;

    if (attribute === 'perc_desconto') {
      percDesconto = (newSubTotal * value) / 100;
      auxSubTotal = newSubTotal - percDesconto + Number(valAcrescimo);
      setNewSubTotalLiquido(auxSubTotal);
      setValue('val_desconto', moneyFormat(percDesconto.toFixed(2)));
      setValDesconto(percDesconto);
    }
    if (attribute === 'perc_acrescimo') {
      if (value > 100) return;
      percAcrescimo = (newSubTotal * Number(value)) / 100;
      auxSubTotal = newSubTotal + percAcrescimo - Number(valDesconto);
      setNewSubTotalLiquido(auxSubTotal);
      setValue('val_acrescimo', moneyFormat(percAcrescimo.toFixed(2)));
      setValAcrescimo(percAcrescimo);
    }
    if (attribute === 'val_desconto') {
      valueDesconto = (value / newSubTotal) * 100;
      auxSubTotal = newSubTotal - value + Number(valAcrescimo);
      setValDesconto(value);
      setNewSubTotalLiquido(auxSubTotal);
      setValue('perc_desconto', pesoFormatado(valueDesconto.toFixed(2), 2));
    }
    if (attribute === 'val_acrescimo') {
      valueAcrescimo = (value / newSubTotal) * 100;
      auxSubTotal = newSubTotal + value - valDesconto;
      setValAcrescimo(value);
      setNewSubTotalLiquido(auxSubTotal);
      setValue('perc_acrescimo', pesoFormatado(valueAcrescimo.toFixed(2), 2));
    }
    return auxSubTotal;
  };

  const handleResetFormModalDesconto = () => {
    reset();
    setValue('val_desconto', 0);
    setValue('val_acrescimo', 0);
    setValAcrescimo(0);
    setValDesconto(0);
    setValue('perc_desconto', '');
    setValue('perc_acrescimo', '');
  };

  const handleConfirmAcrescimoDesconto = () => {
    if (valDesconto > newSubTotal) {
      return toast.warning(
        'O valor do desconto não pode ser maior que o valor bruto.',
      );
    }
    if (val_desconto_max > 0 && valDesconto > val_desconto_max) {
      return toast.warning(
        `Valor de desconto não permitido. Informe um valor de desconto menor que ${moneyFormat(
          val_desconto_max.toFixed(2),
        )} R$`,
      );
    }
    handleChangeOpenModalDesconto(false);
    handleValAcrescimo(valAcrescimo);
    handleValDesconto(valDesconto);
    handleSubTotal(newSubTotalLiquido);
    if (valAcrescimo === 0 && valDesconto === 0) {
      handleSubTotal(newSubTotal);
    }
    handleResetFormModalDesconto();
  };

  useEffect(() => {
    if (isOpenModalDesconto) {
      let auxNewSubTotal = subTotal;
      if (val_desconto > 0) {
        auxNewSubTotal += val_desconto;
        handleCalcDesconto('val_desconto', val_desconto);
        setValue('val_desconto', formatToCurrency(val_desconto.toFixed(2)));
      }
      if (val_acrescimo > 0) {
        auxNewSubTotal -= val_acrescimo;
        handleCalcDesconto('val_acrescimo', val_acrescimo);
        setValue('val_acrescimo', formatToCurrency(val_acrescimo.toFixed(2)));
      }
      setNewSubTotal(auxNewSubTotal);
      setNewSubTotalLiquido(subTotal);
    }
  }, [isOpenModalDesconto]);

  useEffect(() => {
    const handleKeyEnterPress = (ev: KeyboardEvent) => {
      const button = document.getElementById(
        'button-confirm-desconto-acrescimo',
      ) as HTMLButtonElement | null;

      if (isOpenModalDesconto && ev.key === 'Enter' && button) {
        button.click();
      }
    };

    window.addEventListener('keydown', handleKeyEnterPress);
    return () => window.removeEventListener('keydown', handleKeyEnterPress);
  }, [isOpenModalDesconto]);

  return (
    <Modal
      isOpen={isOpenModalDesconto}
      title="Desconto/Acréscimo"
      onClose={() => handleChangeOpenModalDesconto(false)}
    >
      <ButtonContainer>
        <Row>
          <Col sm={12} md={12}>
            <CardTotalizadores bgColor="#C9DEF9">
              <p>Valor Bruto: R$ {moneyFormat(newSubTotal.toString())}</p>
            </CardTotalizadores>
          </Col>

          <Col sm={12} md={6}>
            <InputPercent
              id="perc_desconto"
              placeholder="0,00"
              label="% Desconto"
              min={0}
              max={200}
              maxLength={6}
              decimals={3}
              name="perc_desconto"
              register={register}
              control={control}
              isDisabled={false}
              autoComplete="off"
              isError={!!errors.perc_desconto}
              onInput={(ev: ChangeEvent<HTMLInputElement>) => {
                const { value } = ev.target;
                const valueReplacement = pesoFormatado(value, 2);
                if (Number.isNaN(parseFloat(value))) {
                  setValue('perc_desconto', '0,00');
                } else {
                  setValue('perc_desconto', valueReplacement);
                }
                handleCalcDesconto(
                  'perc_desconto',
                  convertToDecimal(valueReplacement),
                );
              }}
            />
          </Col>
          <Col sm={12} md={6}>
            <InputMoney
              label="R$ Desconto"
              placeholder="0,00"
              min={0}
              decimals={2}
              maxLength={10}
              name="val_desconto"
              register={register}
              control={control}
              isError={!!errors.val_desconto}
              onInput={(ev: any) => {
                const { value } = ev.target;
                handleCalcDesconto(
                  'val_desconto',
                  convertToDecimal(formatToCurrency(value)),
                );
                setValue('val_desconto', formatToCurrency(value));
              }}
              disabled={false}
              style={{ width: '100%' }}
            />
          </Col>
          <Col sm={12} md={6}>
            <InputPercent
              id="perc_acrescimo"
              placeholder="0,00"
              label="% Acréscimo"
              min={0}
              max={100}
              maxLength={6}
              decimals={3}
              name="perc_acrescimo"
              register={register}
              control={control}
              isDisabled={false}
              autoComplete="off"
              isError={!!errors.perc_acrescimo}
              onInput={(ev: ChangeEvent<HTMLInputElement>) => {
                const { value } = ev.target;
                const valueReplacement = pesoFormatado(value, 2);
                if (Number.isNaN(parseFloat(value))) {
                  setValue('perc_acrescimo', '0,00');
                } else {
                  setValue('perc_acrescimo', valueReplacement);
                }
                handleCalcDesconto(
                  'perc_acrescimo',
                  convertToDecimal(valueReplacement),
                );
              }}
            />
          </Col>
          <Col sm={12} md={6}>
            <InputMoney
              label="R$ Acréscimo"
              placeholder="0,00"
              min={0}
              decimals={2}
              maxLength={10}
              name="val_acrescimo"
              register={register}
              control={control}
              isError={!!errors.val_acrescimo}
              onInput={(ev: any) => {
                const { value } = ev.target;
                handleCalcDesconto(
                  'val_acrescimo',
                  convertToDecimal(formatToCurrency(value)),
                );
                setValue('val_acrescimo', formatToCurrency(value));
              }}
              disabled={false}
              style={{ width: '100%' }}
            />
          </Col>
          <Col sm={12} md={12}>
            <CardTotalizadores bgColor="#BFE8C1" style={{ marginTop: 12 }}>
              <p>
                Valor Líquido: R$ {moneyFormat(newSubTotalLiquido.toString())}
              </p>
            </CardTotalizadores>
          </Col>

          <Col sm={12} md={4}>
            <CustomButtonNovo
              onClick={() => {
                setTimeout(() => {
                  handleCalcDesconto('val_desconto', 0);
                  handleCalcDesconto('val_acrescimo', 0);

                  const auxSubTotalTable = subTotalTable(produtosTable);
                  handleSubTotal(auxSubTotalTable);

                  handleValAcrescimo(0);
                  handleValDesconto(0);
                }, 200);

                handleResetFormModalDesconto();

                handleChangeOpenModalDesconto(false);
              }}
              disabled={false}
              // icon={null}
              label="Limpar"
              variant="cancel"
              style={{
                marginTop: 12,
                textTransform: 'uppercase',
              }}
              width="100%"
            />
          </Col>
          <Col sm={12} md={4}>
            <CustomButtonNovo
              onClick={() => {
                handleResetFormModalDesconto();
                handleChangeOpenModalDesconto(false);
              }}
              disabled={false}
              // icon={null}
              label="Cancelar"
              style={{
                backgroundColor: '#dc3545',
                textTransform: 'uppercase',

                marginTop: 12,
              }}
              width="100%"
            />
          </Col>
          <Col sm={12} md={4}>
            <CustomButtonNovo
              onClick={() => handleConfirmAcrescimoDesconto()}
              disabled={false}
              // icon={null}
              label="Ok"
              style={{
                marginTop: 12,
                textTransform: 'uppercase',
              }}
              width="100%"
              variant="confirm"
              id="button-confirm-desconto-acrescimo"
            />
          </Col>
        </Row>
      </ButtonContainer>
    </Modal>
  );
};
